<template>
<div class="chapter">
<div class="inner_page">
<p class="left-1">The mind is its own place,</p>
<p class="left-2">and in itself</p>
<p class="left-2">Can make a heaven of Hell,</p>
<p class="left-2">a hell of Heaven.</p>
<p class="left-4">—<span class="smallcaps">JOHN MILTON</span> (<i>Paradise Lost</i>)</p>
<p class="left-3">This is where the world is made—out here in Hell. But there is no sense to Hell when there are no people in Heaven. Some of us must choose Hell, some Heaven. I have made my choice. And I intend to rule this place if I can, if only to make some sense of it!</p>
<p class="left-4">—<span class="smallcaps">MACK BOLAN</span> (his War Journal)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?51fe088c